import { memo } from 'react';
import { SkeletonCell, SkeletonRow, TableSkeleton } from './Table.styles';

const TableLoadingSkeletonBase = () => (
  <TableSkeleton>
    {Array.from({ length: 6 }).map((_, i) => (
      <SkeletonRow key={i}>
        <SkeletonCell />
        <SkeletonCell />
        <SkeletonCell />
        <SkeletonCell />
      </SkeletonRow>
    ))}
  </TableSkeleton>
);

export const TableLoadingSkeleton = memo(TableLoadingSkeletonBase);
